export enum PromotionItemRuleInclusionType {
    Include = "Include",
    Exclude = "Exclude",
}
